import 'twin.macro'
import 'react-datepicker/dist/react-datepicker.css'

import CalendarIcon from 'assets/icons/CalendarIcon'
import StarIcon from 'assets/icons/StarIcon'
import DatePickerInput from 'components/UI/date-picker-input'
import SubBody from 'components/UI/sub-body/sub-body'
import SubTitle from 'components/UI/sub-title/sub-title'
import dayjs from 'dayjs'
import { useDeviceInfo } from 'hooks/useDeviceInfo'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { useTransactionsQuery } from 'redux/api/lk.api'
import tw from 'twin.macro'

const data = [
  { date: '10.10.23', comment: 'Chaplin Cinemas', status: true, amount: '- 5 600 ₸' },
  { date: '10.10.23', comment: 'Chaplin Cinemas', status: null, amount: '+ 2 990 ₸' },
  { date: '10.10.23', comment: 'Chaplin Cinemas', status: false, amount: '- 5 600 ₸' },
  { date: '10.10.23', comment: 'Chaplin Cinemas', status: true, amount: '- 5 600 ₸' },
  { date: '10.10.23', comment: 'Chaplin Cinemas', status: true, amount: '- 15 000 ₸' }
]
function Statement() {
  const { t } = useTranslation()
  const { isMobile } = useDeviceInfo()
  const {
    state: { cardInfo }
  } = useLocation()

  const [startDate, setStartDate] = useState(new Date(cardInfo.open_date))
  const [endDate, setEndDate] = useState(new Date())

  const { data: transactions } = useTransactionsQuery(
    {
      uuid: cardInfo.uuid,
      date_from: dayjs(startDate).format('YYYY-MM-DD'),
      date_to: dayjs(endDate).format('YYYY-MM-DD')
    },
    { skip: !startDate || !endDate }
  )

  const returnStatusColor = (value: string | null) => {
    switch (value) {
      case '':
        return tw`text-green`
      case 'списание':
        return tw`text-error`
      case 'списание и зачисление':
        return tw`text-secondary`
      default:
        return tw`text-green`
    }
  }

  return (
    <div tw='sm:mt-20 sm:static relative'>
      <h1 tw='font-bold text-s30'>{t('statement.title', { ns: 'cabinet' })}</h1>
      <div tw='grid sm:grid-cols-3 grid-cols-1 gap-4 w-full mt-10'>
        <div tw='bg-secondary rounded-s20 p-6'>
          <SubBody twStyle={tw`text-secondary`}>{t('statement.card', { ns: 'cabinet' })}</SubBody>
          <SubTitle variant='bold'>Mega Card {cardInfo.number_card.split('').slice(10, 16)}</SubTitle>
        </div>
        <div tw='bg-secondary rounded-s20 p-6'>
          <SubBody twStyle={tw`text-secondary`}>{t('statement.available', { ns: 'cabinet' })}</SubBody>
          <SubTitle variant='bold'>{cardInfo.balance} ₸</SubTitle>
        </div>
        <div tw='bg-secondary rounded-s20 p-6 w-full'>
          {/* По дефолту Дата открытия карты и текущую дату */}
          <DatePickerInput
            setEndDate={setEndDate}
            endDate={endDate}
            startDate={startDate}
            setStartDate={setStartDate}
          />
        </div>
      </div>
      {!isMobile && (
        <div tw='grid grid-cols-4 text-left bg-secondary px-5 h-[40px] rounded-s20 items-center mt-6 text-secondary'>
          <SubBody> {t('statement.table.date', { ns: 'cabinet' })}</SubBody>
          <SubBody> {t('statement.table.comments', { ns: 'cabinet' })}</SubBody>
          <SubBody> {t('statement.table.status', { ns: 'cabinet' })}</SubBody>
          <SubBody> {t('statement.table.amount', { ns: 'cabinet' })}</SubBody>
        </div>
      )}

      {transactions?.data?.length !== 0 ? (
        isMobile ? (
          <div tw='text-left bg-secondary px-5 rounded-s20 items-center mt-6'>
            {transactions?.data?.map((item, idx) => (
              <section
                tw='h-[80px] flex flex-col items-center justify-center border border-l-0 border-t-0 border-r-0 font-semibold'
                key={`statement-row-${idx}`}
              >
                <div tw='flex w-full justify-between'>
                  <p tw='text-[15px] font-semibold'>{item.operation_name}</p>
                  <p tw='text-[15px] font-semibold'>
                    {item.incfl_name === 'списание' && '- '}
                    {item.amount} ₸
                  </p>
                </div>
                <div tw='flex w-full justify-between'>
                  <p tw='text-[15px] font-semibold text-secondary'>{dayjs(item?.time).format('DD.MM.YYYY')}</p>
                  <p tw='text-[15px] font-semibold' css={returnStatusColor(item.incfl_name)}>
                    {' '}
                    {item.incfl_name}
                  </p>
                </div>
              </section>
            ))}
          </div>
        ) : (
          <div tw='text-left bg-secondary px-5 rounded-s20 items-center mt-6'>
            {transactions?.data?.map((item, idx) => (
              <section
                tw='h-[80px] grid grid-cols-4 items-center border border-l-0 border-t-0 border-r-0 font-semibold'
                key={`statement-row-${idx}`}
              >
                <p tw='text-secondary'>{dayjs(item?.time).format('DD.MM.YYYY')}</p>
                <p>{item.operation_name}</p>
                <p css={returnStatusColor(item.incfl_name)}>{item.incfl_name}</p>
                <p>
                  {item.incfl_name === 'списание' && '- '}
                  {item.amount} ₸
                </p>
              </section>
            ))}
          </div>
        )
      ) : (
        <div tw='mx-auto text-center flex flex-col items-center gap-3 mt-8'>
          <div tw='bg-secondary rounded-s20 flex items-center justify-center w-[72px] h-[72px]'>
            <StarIcon />
          </div>
          <SubTitle variant='bold'> {t('statement.no_results.title', { ns: 'cabinet' })}</SubTitle>
          <SubBody twStyle={tw`text-secondary`}> {t('statement.no_results.desc', { ns: 'cabinet' })}</SubBody>
        </div>
      )}
    </div>
  )
}

export default Statement
